import SettingHead from '@/components/common/settingHead';
import ParticipantSetting from '@/components/common/participantSetting';
import MainWindowSetting from '@/components/common/MainWindowSetting';
import CloudProxy from '@/components/common/cloudProxy';
import AudioMatrix from '@/components/common/AudioMatrix';
import ShareScreenSetting from '@/components/common/shareScreenSetting';
import AISpeechSetting from '@/components/common/aiSpeechSetting';
import PushToTalk from '@/components/common/pushToTalk';
import Bus from '@/assets/js/bus.js';
import i18n from '@/lang/index.js';
import { mapState } from 'vuex';
export default {
  props: {
    showSetting: {
      type: Boolean,
      default: false
    },
    statusInfo: {
      type: Object,
      default: function () {
        return {};
      }
    },
    currentModule: {
      type: String,
      default: 'party'
    }
  },
  components: {
    SettingHead,
    ParticipantSetting,
    MainWindowSetting,
    CloudProxy,
    AudioMatrix,
    ShareScreenSetting,
    AISpeechSetting,
    PushToTalk
  },
  data() {
    return {
      tabPosition: 'left',
      tabVal: '2',
      tabArray: [{
        label: 'Setting',
        content: '',
        name: '1'
      }, {
        label: 'Participant Setting',
        content: 'participantSetting',
        name: '2',
        disabled: false
      }, {
        label: 'TVU Devices Setting',
        content: 'MainWindowSetting',
        name: '3',
        disabled: false
      }, {
        label: 'Share Screen Setting',
        content: 'ShareScreenSetting',
        name: '4',
        disabled: false
      }, {
        label: 'Proxy Setting',
        content: 'CloudProxy',
        name: '5',
        disabled: false
      }, {
        label: 'Audio Matrix',
        content: 'AudioMatrix',
        name: '6',
        disabled: false
      }, {
        label: 'AI Speech Recognition',
        content: 'AISpeechSetting',
        name: '7',
        disabled: false
      }, {
        label: 'Push To Talk',
        content: 'PushToTalk',
        name: '8',
        disabled: false
      }],
      initOperateData: null,
      initResolution: null,
      initAnyWhereGlobalSetting: null,
      mainWindowType: '',
      audioMatrixEnable: false,
      participantEnable: false
    };
  },
  computed: {
    ...mapState({
      State: state => state
    }),
    returnClass() {
      let _str = 'settingDialog';
      if (this.State.audioMatrixFullScreen) _str += ' matrixFullScreen';
      if (this.tabVal == '6') _str += ' audioMatrix';
      return _str;
    }
  },
  watch: {
    'State.currentModule': function (val) {
      if (val != 'party') {
        this.tabArray = this.tabArray.filter(val => {
          return val.name != '6' && val.name != '7' && val.name != '8';
        });
      } else {
        this.tabArray = this.tabArray.concat([{
          label: 'Audio Matrix',
          content: 'AudioMatrix',
          name: '6',
          disabled: true
        }, {
          label: 'AI Speech Recognition',
          content: 'AISpeechSetting',
          name: '7',
          disabled: true
        }, {
          label: 'Push To Talk',
          content: 'PushToTalk',
          name: '8',
          disabled: true
        }]);
      }
    }
  },
  filters: {
    showTabItems(label) {
      if (label === 'Participant Setting') {
        return i18n.t('setting.participantSetting');
      } else if (label === 'TVU Devices Setting') {
        return i18n.t('setting.devicesSetting');
      } else if (label === 'Setting') {
        return i18n.t('setting.settingName');
      } else if (label === 'Proxy Setting') {
        return i18n.t('setting.proxySetting');
      } else if (label === 'Audio Matrix') {
        return i18n.t('setting.audioMatrix');
      } else if (label === 'Share Screen Setting') {
        return i18n.t('setting.ShareScreenSetting');
      } else if (label === 'AI Speech Recognition') {
        return i18n.t('setting.aiSpeechSetting');
      } else if (label === 'Push To Talk') {
        return i18n.t('pushTalk.pushTalk');
      } else {
        return label;
      }
    }
  },
  created() {
    Bus.$on('initOperateData', val => {
      this.initOperateData = val;
      if (this.initOperateData.vfbBitrate) {
        this.initOperateData.vfbBitrate = typeof this.initOperateData.vfbBitrate === 'string' ? Number(this.initOperateData.vfbBitrate.slice(0, -1)) : this.initOperateData.vfbBitrate;
      }
    });
    Bus.$on('endParty', () => {
      if (this.initOperateData) {
        this.$set(this.initOperateData, this.initOperateData.lockName, undefined);
        if (this.initResolution) {
          this.initResolution.talkBack = false;
        }
      }
    });
    Bus.$on('getAnyWhereGlobalSetting', v => {
      this.initAnyWhereGlobalSetting = v;
    });
    // 获取初始化的分辨率/码率相关数据
    Bus.$on('getInitStatus', v => {
      this.initResolution = v;
    });
    Bus.$on('initMainWindowType', value => {
      this.mainWindowType = value;
    });
    Bus.$on('changeAudioMatrix', val => {
      const {
        host,
        participant
      } = val;
      this.audioMatrixEnable = host == 1;
      this.participantEnable = participant == 1;
    });
  },
  methods: {
    initData() {
      if (this.$route.name === 'party' || this.$route.name === 'partyParticipate') {
        if (this.$route.name === 'manage') {
          this.tabArray.forEach(item => {
            if (item.content === 'AudioMatrix' || item.content === 'AISpeechSetting' || item.content === 'PushToTalk') {
              item.disabled = true;
            }
          });
        } else if (this.$route.name === 'partyParticipate') {
          this.tabArray = this.tabArray.filter(item => {
            if (this.State.audioMatrixEnable && this.State.partiAudioMatrixEnable && item.content == 'AudioMatrix') {
              this.tabVal = '6';
            }
            if (this.State.pushTalkOpen && this.State.participantPushTalkOpen && item.content == 'PushToTalk') {
              this.tabVal = '8';
            }
            return item.name == '1' || this.State.audioMatrixEnable && this.State.partiAudioMatrixEnable && item.content == 'AudioMatrix' || this.State.pushTalkOpen && this.State.participantPushTalkOpen && item.content == 'PushToTalk';
          });
        }
      } else {
        if (this.$route.name === 'manage') {
          this.tabArray.forEach(item => {
            if (item.content === 'AudioMatrix' || item.content === 'AISpeechSetting' || item.content === 'PushToTalk') {
              item.disabled = true;
            }
          });
        } else {
          this.tabArray = this.tabArray.filter(val => {
            return val.name != '6' && val.name != '7' && val.name != '8';
          });
        }
      }
    },
    mutexTip() {
      if (this.State.audioMatrixEnable) {
        this.$message.warning(this.$t('setting.mutexPrompt', {
          featureName: 'Audio Matrix'
        }));
      } else if (this.State.intercomEnable) {
        this.$message.warning(this.$t('setting.mutexPrompt', {
          featureName: 'Intercom'
        }));
      } else {
        this.$message.warning(this.$t('setting.mutexPrompt', {
          featureName: 'Push To Talk'
        }));
      }
    },
    changeTabval(val) {
      this.tabVal = val;
      if (this.$refs.AISpeechSetting && this.$refs.AISpeechSetting[0]) {
        this.$refs.AISpeechSetting[0].scrollToProductionId();
      }
    },
    closeSettingDialog() {
      this.tabVal = this.$route.name === 'partyParticipate' ? '6' : '2';
      this.$emit('callback');
    },
    changeButtonFlag(value, type) {
      if (!this.initOperateData || !value) return;
      if (type === 'hasCopy') {
        this.$set(this.initOperateData, 'hasCopy', value);
      } else if (type === 'hotJar') {
        this.$set(this.initOperateData, 'hotJar', value);
      } else if (type === 'mic') {
        this.$set(this.initOperateData, 'micCameraIconInPip', value);
      } else if (type === 'fullScreen') {
        this.$set(this.initOperateData, 'fullScreen', value);
      } else if (type === 'login') {
        this.$set(this.initOperateData, 'loginButton', value);
      } else if (type === 'lockName') {
        this.$set(this.initOperateData, 'lockName', value);
      } else if (type === 'intercom') {
        this.$set(this.initOperateData, 'intercom', value);
      } else if (type === 'lazyAudio') {
        this.$set(this.initResolution, 'talkBack', value);
      } else if (type === 'resolution') {
        this.$set(this.initResolution, 'videoQuality', value);
      } else if (type === 'hearThemSelf') {
        this.$set(this.initOperateData, 'hearThemSelf', value);
      } else if (type === 'mainWindow') {
        this.$set(this.initOperateData, 'vfbResolution', value.vfbResolution);
        this.$set(this.initOperateData, 'vfbFrameRate', value.vfbFrameRate);
        this.$set(this.initOperateData, 'vfbBitrate', value.vfbBitrate);
        this.$set(this.initOperateData, 'volume', value.volume);
        this.$set(this.initOperateData, 'pipVolume', value.pipVolume);
      } else if (type === 'cloudProxy') {
        this.$set(this.initOperateData, 'cloudProxy', value);
      } else if (type === 'chatlio') {
        this.$set(this.initOperateData, 'chatlio', value);
      } else if (type == 'volumeEffect') {
        this.$set(this.initOperateData, 'volumeEffect', value);
      } else if (type == 'globalAnyWhereButton') {
        this.$set(this.initOperateData, 'anywhereGlobalSetting', value);
      } else if (type === 'globalAnyWhereSetting') {
        this.$set(this.initAnyWhereGlobalSetting, 'defaultView', value.defaultView);
        this.$set(this.initAnyWhereGlobalSetting, 'lockScreen', value.lockScreen);
        this.$set(this.initAnyWhereGlobalSetting, 'resolutionFps', value.resolutionFps);
        this.$set(this.initAnyWhereGlobalSetting, 'switchCamera', value.switchCamera);
      }
    },
    handClick(info) {
      if (info.disabled) {
        this.$message.warning(this.$t('common.notAllowed'));
        return;
      }
      if (info.name == 6) {
        Bus.$emit('getAllParticipantInfo', 'notNeedJudge');
      }
    }
  }
};